import { AppMode } from '@upflowy/types';

import { inIframe } from './in-iframe';

export const isStandalone = (url: URL): AppMode => {
  const mode = url.searchParams.get('mode');
  if (mode && ['embedded', 'standalone'].includes(mode)) {
    return mode as AppMode;
  }
  return inIframe() ? 'embedded' : 'standalone';
};
